module.exports = __webpack_public_path__ + "static/media/gill_aqua_parka_wetsuit.12a9f08c.jpg";